import { App, ComponentPublicInstance } from 'vue'

declare global {
  interface Window {
    compatWarnings: string[]
  }
}

const traceExceptions = [
  'DynamicScroller',
  'RecycleScroller',
]

window.compatWarnings = []

export const compatWarningHandler = (app: App, flags?: string[]): void => {
  app.config.warnHandler = (message: string, _: ComponentPublicInstance | null, trace: string) => {
    const regex = /\(deprecation (?<flag>[A-Z_]+)\)/
    const match = regex.exec(message)
    const flag = match?.groups?.flag
    if (flag != null) {
      if (traceExceptions.some((exception) => trace.includes(exception))) { return }
      if (flags == null || flags.includes(flag)) {
        window.compatWarnings.push(`${message} ${trace}`)
      }
    }
    // eslint-disable-next-line no-console
    console.warn(message, trace)
  }
} 
